import React from 'react'
import styled from 'styled-components'
import { translate } from 'loankeeper-common/helpers'
import { LKButton } from 'loankeeper-common/components'

import LKModal from './LKModal'
import LKModalContainer from './container'
import { open } from './actions'

export const INFO_MODAL_NAME = 'INFO_MODAL_NAME'

export const openInfo = (message, code, onClose) => open({ name: INFO_MODAL_NAME, message, code, onClose }, code)

const Wrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`

// TODO: find onClose usage and merge with LKModal {onClose} if possible
const InfoModal = (props) => {
  const { modalInstanceName, message, closeModal, params } = props
  const closeInfoModal = () => {
    if (params && params.onClose) {
      params.onClose(closeModal)
    } else {
      closeModal()
    }
  }

  return (
    <LKModal
      name={modalInstanceName}
      heading={translate('LKMESSAGE-MSG_INFO')}
      dataAttributes={params && params.code && { 'data-code': params.code }}
      size="xxs"
      onClose={() => {
        params?.onClose && params.onClose(closeModal)
      }}
      footer={
        <LKModal.Footer>
          <LKButton.Okay onClick={closeInfoModal} />
        </LKModal.Footer>
      }
    >
      <Wrapper dangerouslySetInnerHTML={{ __html: message }}></Wrapper>
    </LKModal>
  )
}

export default LKModalContainer(INFO_MODAL_NAME)(InfoModal)
